import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import TeamDetail from "@/pages/TeamDetail";
import TeamAnalysis from "@/pages/TeamAnalysis";
import TeamQRPrint from "@/pages/TeamQRPrint";
import TeamCompare from "@/pages/TeamCompare";
import PlayerProfile from "@/pages/PlayerProfile";
import PublicTest from "@/pages/PublicTest";
import TestResult from "@/pages/TestResult";
import DemoTest from "@/pages/DemoTest";
import DemoResult from "@/pages/DemoResult";

function App() {
  return (
    <div className="App noise-overlay">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/demo" element={<DemoTest />} />
            <Route path="/demo/:demoId" element={<DemoResult />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teams/:teamId"
              element={
                <ProtectedRoute>
                  <TeamDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teams/:teamId/analysis"
              element={
                <ProtectedRoute>
                  <TeamAnalysis />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teams/:teamId/qr-print"
              element={
                <ProtectedRoute>
                  <TeamQRPrint />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teams/:teamId/compare"
              element={
                <ProtectedRoute>
                  <TeamCompare />
                </ProtectedRoute>
              }
            />
            <Route
              path="/players/:playerId"
              element={
                <ProtectedRoute>
                  <PlayerProfile />
                </ProtectedRoute>
              }
            />
            <Route path="/test/:token" element={<PublicTest />} />
            <Route path="/test/:token/result" element={<TestResult />} />
          </Routes>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#111214",
                border: "1px solid rgba(204,255,0,0.3)",
                color: "#ffffff",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
